import { ReactNode, lazy, Suspense } from "react";
import { DesktopSidebar, MobileTabBar } from "@/components/AppNavigation";

const AICoachChat = lazy(() => import("@/components/dashboard/AICoachChat"));

const AppLayout = ({ children }: { children: ReactNode }) => (
  <div className="flex min-h-screen bg-background">
    <DesktopSidebar />
    <main className="flex-1 pb-20 md:pb-0 overflow-y-auto" role="main" aria-label="Main content">
      <div className="border-b border-border/40 bg-card/50 backdrop-blur-sm h-0 md:h-0" />
      {children}
    </main>
    <MobileTabBar />
    <Suspense fallback={null}>
      <AICoachChat />
    </Suspense>
  </div>
);

export default AppLayout;
